import ApolloClient from "apollo-boost";
import gql from "graphql-tag";
import { store } from "../store/store";
import router from "../router/index";
import { GT_ENDPOINT } from "./settings";
const apolloClient = new ApolloClient({
  uri: GT_ENDPOINT,
  credentials: "include",
});
const SIGNIN_WITH_TOKEN_MUTATION = gql`
  mutation signInWithToken($token: String!) {
    signInWithToken(token: $token) {
      token
      id
      agentId
      username
      name
      accessSettings {
        groupName
        settingName
        settingValue
      }
      agent {
        financeSettings {
          currencyCode
        }
        languageId
        name
        companyCode
      }
      owner {
        id
        name
      }
      email
      logo
      department
      brand
      destinationId
      domain
      vueSettings
      config {
        dateFormat
        defaultLanguageId
        maxUsers
        isSupervisor
        isSupplier
      }
    }
  }
`;

const SIGNIN_OUT_MUTATION = gql`
  mutation logout {
    logout {
      id
    }
  }
`;

export const signOut = (route) => {
  return apolloClient
    .mutate({
      mutation: SIGNIN_OUT_MUTATION,
    })
    .catch((err) => console.log(err));
};
export const signInUsingToken = (route) => {
  const { token } = route.query;
  apolloClient
    .mutate({
      mutation: SIGNIN_WITH_TOKEN_MUTATION,
      variables: { token },
    })
    .then((data) => {
      store.dispatch("storeUser", data.data.signInWithToken).then((r) => {
        router.replace(route.path);
      });
    })
    .catch((err) => console.log(err));
};



// WEBPACK FOOTER //
// ./src/constants/apollo-gtweb-client.js